import Entity from '../entity'
export default class CompanyRelationship extends Entity<number> {
    companyId: number;
    relatedCompanyId: number;
    categoryId: number | null;
    originId: number | null;
    destinationId: number | null;
}
